<template>
  <div
    class="card shadow position-relative"
    style="min-height:120px;"
  >
    <div
      v-if="isEditable"
      class="position-absolute cursor-pointer"
      style="right:8px; top: 8px;"
      @click="edit"
    >
      <v-icon icon="pen" />
    </div>
    <div class="card-body d-flex">
      <div class="d-flex flex-column mx-auto">
        <div class="d-flex mx-auto mb-1">
          <slot name="icon" />
        </div>
        <div class="d-flex mx-auto">
          <slot name="title" />
        </div>
        <div class="my-auto d-flex flex-column text-center fw-bold">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    modalComponent: {
      type: [String, null],
      default: null,
    },
  },
  methods: {
    edit() {
      this.$emit('edit', this.modalComponent);
    },
  },
};
</script>
